<template>
  <div class="match-item box-item" @click="toUrl(`${itemData.web_url}`)">
    <div class="img-wrap">
      <el-image fit="cover" class="img" :src="itemData.img"></el-image>
      <div class="submit-num" v-if="showSubmitNum">投稿数：{{itemData.submitNum}}</div>
      <span class="sta sta-1" v-if="showSta&&itemData.sta==1">已投稿</span>
      <span class="sta sta-2" v-if="showSta&&itemData.sta==2">未投稿</span>
      <span class="sta sta-3" v-if="showSta&&itemData.sta==3">已截稿</span>
    </div>
    <div class="title">{{itemData.title}}</div>
    <div class="desc z-flex z-flex-end">截稿时间:{{itemData.deadline}}</div>
  </div>
</template>

<script>
export default {
  name: "matchItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    },
    showSubmitNum:{
      type:Boolean,
      default:false,
    },
    showSta:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      // this.$router.push({
      //   path:url,
      // })
      // 1.0版先跳转到赛事详情页
      window.open(url, '_blank');
    }
  },
};
</script>

<style lang="scss" scoped>
.img-wrap{
  position: relative;
  .submit-num{
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 12px;
    color:#fff;
    padding: 3px 6px;
    background: rgba(0,0,0,.5);
    border-radius: 4px;
  }
  .sta{
    position: absolute;
    left: 0;
    top: 0;
    font-size: 14px;
    color:#fff;
    padding: 3px 6px;
    border-bottom-right-radius: 4px;
    &.sta-1{
      background:$colorGreen;
    }
    &.sta-2{
      background:$colorRed;
    }
    &.sta-3{
      background:#888;
    }
  }
}
</style>
